import './app.css';


/*eslint-disable no-unused-vars*/
/*eslint-disable no-console*/

import Swiper from 'swiper';

/* is production */
const isProd = process.env.NODE_ENV === 'production';

var isMobile = false; 
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {isMobile = true;}


/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
const data = require('./js/data.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', 'Play'); */

const analyticsEvent = (category, action, label) => {
    const dataLayer = window.dataLayer = window.dataLayer || [];

    dataLayer.push({
        'event': 'eventTracking',
        'category': category,
        'action': action,
        'label': label
    });
};

/* track events from html attributes */
const trackingElements = document.querySelectorAll('[data-event][data-event-category][data-event-label]');

if (trackingElements.length > 0) {
    trackingElements.forEach(trackingElem => {
        trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
            analyticsEvent(
                trackingElem.getAttribute('data-event-category'),
                trackingElem.getAttribute('data-event'),
                trackingElem.getAttribute('data-event-label')
            );
        });
    });
}

analyticsEvent('Page', 'Load', 'Sucsess');

/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    custom: {
        families: ['rostovregular:n3', 'JournalSans:n3,n4'],
        urls: ['./css/fonts.css']
    },
    google: {
        families: ['Roboto:300,400,500,700,900:cyrillic']
    }
});

/* image lazy load */

[].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {
    img.setAttribute('src', img.getAttribute('data-src'));
    img.onload = function() {
        img.removeAttribute('data-src');
    };
});

/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (navigator.share !== undefined) {
    document.querySelector('.share__item--all').classList.add('share__item--show');
}

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                navigator.share({
                    title: shareOptions.title,
                    url: shareOptions.url
                });
            } else {
                VanillaSharing[button.dataset.social](shareOptions);
            }

            analyticsEvent('Share', 'click', 'Social: ' + button.dataset.social);
        });
    });

}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}

var mainSwiper = new Swiper('.swiper-container', { 
    allowTouchMove: false,
    effect: 'fade',
    initialSlide: 3,
        keyboard:{
            enabled: true,
            onlyInViewport: true
        }
});

const wordCheck = (word) => {
    if (word === '<b>' || word === '</b>' || word === '<br />' || word === '<br>' || word === ' ') {
        return false;
    } else {
        return true;
    }
}

const showText = (container) => {
    let text = container.innerHTML;
    text = text.replace(/>/g, "> ");
    text = text.replace(/</g, " <")
          let testWord = container.querySelector('span')
          if (!testWord) {
          let words = text.split(" ");

          container.innerHTML = '';
          let contText = '';
          words.forEach(word => {
                if (wordCheck(word)) {
                  contText += `<span class="hide">${word}</span> `;
                } else {contText += `${word}`;}
           });
          
          contText = contText.replace(/<span class="hide"><\/span>/g, "");
          
          container.innerHTML = contText;

            let hidden = [...container.querySelectorAll('.hide')];
            let offset = 0;
              hidden.forEach(word => {
                setTimeout(function() { 
                    word.classList.remove('hide');
                 }, 200 + offset);
                offset += 50;
            });
            }
}



if (!isMobile) {

    let oneSwiper = new Swiper('.swiper-container-one', { 
        direction: 'vertical',
        mousewheel: true,
        speed: 800,
        keyboard:{
            enabled: true,
            onlyInViewport: true
        }
    });

    let twoSwiper = new Swiper('.swiper-container-two', { 
        direction: 'vertical',
        mousewheel: true,
        speed: 800,
        keyboard:{
            enabled: true,
            onlyInViewport: true
        }
    });

    let threeSwiper = new Swiper('.swiper-container-three', { 
        direction: 'vertical',
        mousewheel: true,
        speed: 800,
        keyboard:{
            enabled: true,
            onlyInViewport: true
        }
    });

    let oneSwiperSlides = [...document.querySelectorAll('.chapterone .swiper-slide')];
    let twoSwiperSlides = [...document.querySelectorAll('.chaptertwo .swiper-slide')];

    oneSwiper.on('slideChange', function () {
      let container = oneSwiperSlides[oneSwiper.activeIndex].querySelector('p');   
      if (container) showText(container);     
    });

    twoSwiper.on('slideChange', function () {
      let container = twoSwiperSlides[twoSwiper.activeIndex].querySelector('p');
      if (container) showText(container);      
    });


    mainSwiper.on('slideChange', function () {
        let container = '';
      if (mainSwiper.activeIndex === 0) {
         container = oneSwiperSlides[oneSwiper.activeIndex].querySelector('p');
      } else if (mainSwiper.activeIndex === 1) {
         container = twoSwiperSlides[twoSwiper.activeIndex].querySelector('p');
        } 
      if (container) showText(container);
      let slideInd = mainSwiper.activeIndex + 1;
      slideInd = slideInd.toString();
      analyticsEvent('Page', 'Part', `Part ${slideInd} opened`); 
    });



}

const chapterSelectors = [...document.querySelectorAll('.chapter-selector__button')];


const clearActives = () => {
    chapterSelectors.forEach(button => button.classList.remove('active'))}

document.getElementById('chapone').addEventListener('click', () => {
    /*
    if (!isMobile) oneSwiper.slideTo(0, 0);
    */
    mainSwiper.slideTo(0);  
    clearActives();
    chapterSelectors[0].classList.add('active');
})

document.getElementById('chaptwo').addEventListener('click', () => {
    /*
    if (!isMobile) twoSwiper.slideTo(0, 0);  
    */
    mainSwiper.slideTo(1);    
    clearActives();
    chapterSelectors[1].classList.add('active');
})

document.getElementById('chapthree').addEventListener('click', () => {
    /*
    if (!isMobile) threeSwiper.slideTo(0, 0);
    */
    mainSwiper.slideTo(2);
    clearActives();
    chapterSelectors[2].classList.add('active');
})

document.getElementById('start').addEventListener('click', () => {
    document.querySelector('.preloader').classList.add('hide');
    analyticsEvent('Page', 'Load', 'Preview');
    setTimeout(() => { 
         document.querySelector('.share-block').classList.remove('hidden');
    }, 1000);
   

})

mainSwiper.on('slideChange', function () {
    let slideNum = mainSwiper.activeIndex;
    clearActives();
    if (slideNum < 3) chapterSelectors[slideNum].classList.add('active');

    if(mainSwiper.slides.length > 3) mainSwiper.removeSlide(3);
});


/*
const iframes = [...document.querySelectorAll('iframe')];

console.log(iframes)

iframes.forEach(iframe => {
    iframe.addEventListener('click', () => {
        console.log('check')
        iframe.parentElement.focus();
    });
});
*/



/* jquery [UNCOMMENT THE LINE BELOW TO USE JQUERY IN JS] */
/* window.$ = window.jQuery = require('jquery'); */



// WEBPACK FOOTER //
// ./app.js